import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"

import AccentTitleDivider from "../shared/accent-title-divider"
import { UIContext } from "../shared/layout"
import Grid from "../shared/grid"
import {
  ContentWrapper,
  StyledImage,
  DetailsWrapper,
  TitleText,
  BodyText,
} from "./venue-data.style"
import VisibilityProvider from "../shared/visibility-provider"

const VenueData = () => {
  const {
    state: { breakpoint },
  } = useContext(UIContext)

  const { locationDataSrc, geometryDataSrc, draftPublishSrc } =
    useStaticQuery(graphql`
      query {
        locationDataSrc: file(
          relativePath: {
            eq: "1_SOLUTIONS/Mapping CMS/Desktop/location_data.svg"
          }
        ) {
          publicURL
        }
        geometryDataSrc: file(
          relativePath: { eq: "1_SOLUTIONS/Indoor Mapping/geometry.jpg" }
        ) {
          publicURL
        }
        draftPublishSrc: file(
          relativePath: {
            eq: "1_SOLUTIONS/Mapping CMS/Desktop/draft_publish_CMS_new.png"
          }
        ) {
          publicURL
        }
      }
    `)

  return (
    <>
      <AccentTitleDivider>Managing Your Venue Data</AccentTitleDivider>
      <ContentWrapper>
        <Grid>
          <VisibilityProvider>
            <StyledImage
              className="location-data"
              src={locationDataSrc.publicURL}
              desktopGrid={"2 / 7"}
              alt={"1. Your CMS Data, 2. Mappedin CMS, 3. Digital Solutions"}
            />
          </VisibilityProvider>
          <VisibilityProvider>
            <DetailsWrapper desktopGrid={"-6 / -1"}>
              <TitleText>Location Data</TitleText>
              <BodyText>
                Mappedin customers can maintain location data by either syncing
                to a central CMS or leveraging our CMS as the source of truth.
                Our flexible mapping platform can handle anything from
                high-level to very granular location data.
              </BodyText>
            </DetailsWrapper>
          </VisibilityProvider>
          <VisibilityProvider>
            <DetailsWrapper desktopGrid={"2 / 7"}>
              <TitleText>Geometry</TitleText>
              <BodyText>
                Maintain splits, merges, renovations, maintenance closures,
                connections, and more with our Editor tools. With all geometry
                geo-referenced to real-world measurements, your map can be used
                for a variety of use cases.
              </BodyText>
            </DetailsWrapper>
          </VisibilityProvider>
          <VisibilityProvider>
            <StyledImage
              className="geometry"
              src={geometryDataSrc.publicURL}
              desktopGrid={"-6 / -1"}
              alt={
                "A laptop displaying the Mappedin CMS editing the geometry of a venue."
              }
            />
          </VisibilityProvider>
          <VisibilityProvider>
            <StyledImage
              className="draft-pubish"
              src={draftPublishSrc.publicURL}
              desktopGrid={"2 / 7"}
              alt={
                "A laptop displaying the difference between draft and live data in the Mappedin CMS."
              }
            />
          </VisibilityProvider>
          <VisibilityProvider>
            <DetailsWrapper desktopGrid={" -6 / -1"}>
              <TitleText>Draft & Publish</TitleText>
              <BodyText>
                With collaborative features such as Draft & Publish mode, teams
                can work together to make, review, and publish changes at the
                appropriate times.
              </BodyText>
            </DetailsWrapper>
          </VisibilityProvider>
        </Grid>
      </ContentWrapper>
    </>
  )
}

export default VenueData
